<div class="modal-header">
  <ng-container [ngSwitch]="tenant">
    <h6 class="fw-bolder" *ngSwitchCase="'default'">{{ 'do-payment-dialog.default.title' | translate }}</h6>
    <h6 class="fw-bolder" *ngSwitchCase="'sdv'">{{ 'do-payment-dialog.sdv.title' | translate }}</h6>
  </ng-container>
</div>
<div class="modal-body">
  <ng-container [ngSwitch]="tenant">
    <ng-container *ngSwitchCase="'default'">
      <p>{{ 'do-payment-dialog.default.text' | translate }}</p>
    </ng-container>

    <ng-container *ngSwitchCase="'sdv'">
      <ng-container *ngIf="isPaymentHistoryLoaded; else paymentHistoryLoading">
        <ng-container *ngIf="selectedPaymentMethod === 'banktransfer'; else sdvText">
          <p>{{ 'do-payment-dialog.sdv.sepa-text.part-1' | translate }}</p>
          <p>{{ 'do-payment-dialog.sdv.sepa-text.part-2' | translate }}</p>
        </ng-container>
        <ng-template #sdvText>
          <p>{{ 'do-payment-dialog.sdv.text' | translate }}</p>
        </ng-template>
      </ng-container>
      <ng-template #paymentHistoryLoading>
        <div class="d-flex justify-content-center py-3">
          <span
            class="spinner-border text-primary"
            role="status"
            aria-label="Loading"
          ></span>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>
<div class="modal-footer">
  <button
    class="btn btn-outline-primary"
    (click)="doPayment()"
  >
    {{ 'button.start-new-payment' | translate }}
  </button>
  <button
    class="btn btn-primary"
    (click)="bsModalRef.hide()"
  >
    {{ 'button.cancel' | translate }}
  </button>
</div>
